import React from 'react';
import { FooterView } from '../Components';
import './ProductServices.css';
import imagSceAne from '../../assets/clothes_Img/clothes_img_1.png';
import imagSceBne from '../../assets/clothes_Img/clothes_img_2.png';
import imagSceCne from '../../assets/clothes_Img/clothes_img_3.png';
import imagSceDne from '../../assets/clothes_Img/clothes_img_4.png';
import imagSceEne from '../../assets/clothes_Img/clothes_img_5.png';
import imagSceFne from '../../assets/clothes_Img/clothes_img_6.png';
import imagSceGne from '../../assets/clothes_Img/clothes_img_7.png';
import imagSceHne from '../../assets/clothes_Img/clothes_img_8.png';

import imaAgCalm from '../../assets/clothes_Img/clothes_img_9.png';
import imaBgCalm from '../../assets/clothes_Img/clothes_img_10.png';
import imaCalm from '../../assets/clothes_Img/clothes_img_11.png';
import imagDCalm from '../../assets/clothes_Img/clothes_img_12.png';
import imag_alm from '../../assets/clothes_Img/clothes_img_13.png';
import imagMake_a from '../../assets/clothes_Img/clothes_img_14.png';
import imagMake_b from '../../assets/clothes_Img/clothes_img_15.png';
import imagMake_c from '../../assets/clothes_Img/clothes_img_16.png';
import imagMake_d from '../../assets/clothes_Img/clothes_img_17.png';
import imagMake_e from '../../assets/clothes_Img/clothes_img_18.png';
import imagA_develop from '../../assets/clothes_Img/clothes_img_19.png';
import imagB_develop from '../../assets/clothes_Img/clothes_img_20.png';
import imagC_develop from '../../assets/clothes_Img/clothes_img_21.png';
import imagD_develop from '../../assets/clothes_Img/clothes_img_22.png';
import imagE_develop from '../../assets/clothes_Img/clothes_img_23.png';
import imagF_develop from '../../assets/clothes_Img/clothes_img_24.png';

const ProductServices = () => {
  const applicableArr = [
    {
      url: imagSceAne,
      name: '物流',
    },
    {
      url: imagSceBne,
      name: '科技',
    },
    {
      url: imagSceCne,
      name: '跨境贸易',
    },
    {
      url: imagSceDne,
      name: '医药行业',
    },
    {
      url: imagSceEne,
      name: '工程',
    },
    {
      url: imagSceFne,
      name: '地产',
    },
    {
      url: imagSceGne,
      name: '国际运输',
    },
    {
      url: imagSceHne,
      name: '商旅',
    },
  ];

  const customArr = [
    {
      url: imagMake_b,
      name: '专项模块定制化',
    },
    {
      url: imagMake_c,
      name: '风控逻辑定制',
    },
    {
      url: imagMake_d,
      name: '业务流程定制',
    },
    {
      url: imagMake_e,
      name: '审批流程定制',
    },
  ];

  const ProvideList = [
    {
      url: imaAgCalm,
      name: '电子签章',
      text: '支持安心签、上上签等多平台电子签约、即办即用、提升效率节约成本',
    },
    {
      url: imaBgCalm,
      name: '中登网一键批量智能 登记、查询',
      text: '自动智能批量查询&下载客户中登登记资料、一键登记应收账款信息至中登网',
    },
    {
      url: imaCalm,
      name: '发票智能识别、查验',
      text: '智能OCR识别发票信息、国税平台发票真伪验证、批量上传发票信息',
    },
    {
      url: imagDCalm,
      name: '企业工商信息、经营 信息查询',
      text: '与第三方数据接通进行企业信息查询、根据第三方数据和内部数据进行风险预警',
    },
    {
      url: imag_alm,
      name: '内置强大BI数据分析引擎',
      text: '自动生成多维度数据图表、业务需求和数据多重组合、提高企业抗风险能力',
    },
  ];
  const operationaList = [
    '客服支持',
    '资产收集',
    '单证审核',
    '数据跟踪',
    '方案设计',
    'IT支持',
  ];
  const developmentList = [
    {
      url: imagA_develop,
      num: 1,
      text: '咨询阶段',
      content:
        '安排产品经理与您沟通,一起梳理需求,出基本的方案和报价,把想法落地为"软件设计"',
    },
    {
      url: imagB_develop,
      num: 4,
      text: '程序实现',
      content: '开发人员根据设计确定系统构架、开发环境、数据库并完成代码编写',
    },
    {
      url: imagC_develop,
      num: 2,
      text: '签订合同',
      content: '客户确认需求,签订合同,我方确定此次项目的技术团队',
    },
    {
      url: imagD_develop,
      num: 5,
      text: '验收交付',
      content: '测试工程师进行多维度模拟测试,确认系统无异常情况后交付并上线',
    },
    {
      url: imagE_develop,
      num: 3,
      text: 'UI设计',
      content: '项目团队出产品原型设计、Ul效果渲染图,发给客户沟通,确认',
    },
    {
      url: imagF_develop,
      num: 6,
      text: '后期维护',
      content: '对客户进行软件安装、使用培训,并进行后期bug的维护',
    },
  ];
  return (
    <div className="ProductServices">
      <div className="ProductServicesPage">
        <div className="ProductServicesBg">
          <div className="ServicesPage">
            <div className="ServicesHeaderText">系统服务</div>
            <div className="ServicesText">SERVICES</div>
            <div className="ServicesBorder"></div>
          </div>
          {/* 适用场景 */}
          <div className="ApplicableScenarios">
            <div className="ApplicableHeaderText">
              适用场景
              <div className="Dark" />
            </div>
            <div className="ApplicableList">
              {applicableArr.map((item, ind) => {
                return (
                  <div className="ApplicableBox" key={ind}>
                    <img className="ApplicableImg" src={item.url} alt="" />
                    <div className="ApplicableText">{item.name}</div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* 提供服务 */}
          <div className="ProvideServices">
            <div className="ProvideHeaderText">
              提供服务
              <div className="Dark" />
            </div>
            <div className="ProvideList">
              {ProvideList.map((item, ind) => {
                return (
                  <div className="ProvideListItem" key={ind}>
                    <div className="ProvideItemBox">
                      <div style={{ height: '120px' }}>
                        {' '}
                        <img className="ProvideImg" src={item.url} alt="" />
                      </div>
                      <div style={{ height: '120px' }}>
                        <div className="ProvideText">{item.name}</div>
                      </div>

                      <div className="Providearticle">{item.text}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/*运营服务  */}
          <div className="OperationalServices">
            <div className="OperationalPage">
              <div className="OperationalHeaderText">运营服务</div>
              <div className="OperationalText">OPERATION SERVICE</div>
              <div className="OperationalBorder" />
            </div>
            <img className="OperationalImg" src={imagMake_a} alt="" />
            <div className="OperationaList">
              {operationaList.map((item, ind) => {
                return (
                  <div key={ind} className="OperationaListItem">
                    {item}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        {/* 定制服务 */}
        <div className="CustomServices">
          <div className="CustomServicesPage">
            <div className="CustomServicesHeaderText">定制服务</div>
            <div className="CustomServicesText">SERVICE TO ORDER</div>
            <div className="CustomServicesBorder" />
          </div>
          <div className="CustomServicesList">
            {customArr.map((item, ind) => {
              return (
                <div className="CustomServicesBox" key={ind}>
                  <img className="CustomServicesImg" src={item.url} alt="" />
                  <div className="CustomServicesTextA">{item.name}</div>
                </div>
              );
            })}
          </div>
        </div>
        {/* 开发流程 */}
        <div className="DevelopmentProcess">
          <div className="DevelopmentProcessText">
            开发流程
            <div className="Dark" />
          </div>
          <div className="Development_List">
            {developmentList.map((item, ind) => {
              return (
                <div className="DevelopmentList_Item" key={ind}>
                  <img className="DevelopmentListImg" src={item.url} alt="" />
                  <div className="DevelopmentSerial_Number">{item.num}</div>
                  <div className="Development_Content">
                    <div className="Development_Text">{item.text}</div>
                    <div className="DevelopmentText_Content">
                      {item.content}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <FooterView />
    </div>
  );
};

export default ProductServices;
